import { render, staticRenderFns } from "./stroeMangement.vue?vue&type=template&id=2fae1470&scoped=true&"
import script from "./stroeMangement.vue?vue&type=script&lang=js&"
export * from "./stroeMangement.vue?vue&type=script&lang=js&"
import style0 from "./stroeMangement.vue?vue&type=style&index=0&id=2fae1470&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fae1470",
  null
  
)

export default component.exports